module.exports = __webpack_public_path__ + "img/ga.b8cd2c39.svg";